<template>
    <v-container class="fill-height" fluid>
        
    </v-container>
</template>

<script> 
  import { mapMutations } from 'vuex'  

  export default {   
    created() {
        this.logout();
        this.setDrawer(false);        
        this.$router.push({name: 'Login'});
    },     
    methods: {        
        ...mapMutations('auth', ['logout']),
        ...mapMutations('app', ['setDrawer'])        
    }
  }
</script>
